// removed by extract-text-webpack-plugin
module.exports = {"component":"_3kBkaVbrrtKsLLHTPJB7Am","tactTitle":"W5J6qqxSw5gz-J7EN7dkC","tactLink":"_30L0dD_f1azkArUV6uyiJL","tactTxt":"_32Dth81MxDjRrCTkfyQ35g"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/About/About.scss
 ** module id = 1046
 ** module chunks = 0
 **/